import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'td[mobile-cell]',
  templateUrl: './mobile-cell.component.html',
  styleUrls: ['./mobile-cell.component.scss'],
})
export class MobileCellComponent implements OnInit {

  constructor() {
  }

  @Input() title = "";

  ngOnInit(): void {
  }

}
